import React from "react"
import { ColorInputHex } from "./color-input-hex"
import { ColorInputSwatch } from "./color-input-swatch"

/**
 * A swatch and hex box for a panel with no field of its own, such as one in a
 * toolbar `Menu`. Place it before `ColorPanel.Picker`.
 */
export function ColorPanelHex() {
  return (
    <div
      data-slot="color-panel-hex"
      className="flex items-center gap-2 rounded border border-gray-200 py-1 pr-3 pl-1"
    >
      <ColorInputSwatch />
      <ColorInputHex accessibleName="Hex color" />
    </div>
  )
}

ColorPanelHex.displayName = "ColorPanel.Hex"
